import { Stack } from '@mui/material';
import LmTextField from '../../../../components/common/LmTextField';
import VegaFormInputField from '../../../../components/common/VegaFormInputField';
import {
  getConfigurationState,
  setConfigurations,
} from '../../../../features/configurationSlice';
import { useAppDispatch, useAppSelector } from '../../../../store';
import {
  ConfigValueProps,
  ConfigurationDto,
} from '../../../../types/configurationType';

const LeaveRequestForm = () => {
  const { configurations } = useAppSelector(getConfigurationState);
  const dispatch = useAppDispatch();

  const handleConfigChange = (key: keyof ConfigurationDto, value: any) => {
    const updateConfig = { ...configurations, [key]: value };
    dispatch(setConfigurations(updateConfig));
  };

  const handleLeaveRequestChange = (
    key: keyof ConfigValueProps,
    value: number | string
  ) => {
    const updateConfigValueObj = { ...configurations.config, [key]: value };
    handleConfigChange('config', updateConfigValueObj);
  };

  return (
    <Stack gap={2}>
      <VegaFormInputField label={'Leave Request Deadline'}>
        <LmTextField
          type="number"
          value={configurations.config?.leaveRequestDeadline ?? 0}
          onChange={e => {
            const value = e.target.value && parseFloat(e.target.value);
            handleLeaveRequestChange('leaveRequestDeadline', value);
          }}
        />
      </VegaFormInputField>
      <VegaFormInputField label={'Reminder for Leave Approval to Supervisor'}>
        <LmTextField
          type="number"
          value={configurations.config?.reminderTimePeriod ?? 0}
          onChange={e => {
            const value = e.target.value && parseFloat(e.target.value);
            handleLeaveRequestChange('reminderTimePeriod', value);
          }}
        />
      </VegaFormInputField>
      <VegaFormInputField label={'Approval Deadline'}>
        <LmTextField
          type="number"
          value={configurations.config?.approvalDeadline ?? 0}
          onChange={e => {
            const value = e.target.value && parseFloat(e.target.value);
            handleLeaveRequestChange('approvalDeadline', value);
          }}
        />
      </VegaFormInputField>
      <VegaFormInputField label={'Next level escalation deadline'}>
        <LmTextField
          type="number"
          value={configurations.config?.escalationDeadline ?? 0}
          onChange={e => {
            const value = e.target.value && parseFloat(e.target.value);
            handleLeaveRequestChange('escalationDeadline', value);
          }}
        />
      </VegaFormInputField>
    </Stack>
  );
};

export default LeaveRequestForm;
